module.exports = __webpack_public_path__ + "img/08b-for-approval-view.8875b338.png";